import request from 'utils/request'
/*-----------   财务分析   ----------*/
// table
export const getChartList = data => request().post('finance/analyse', data)
//杜邦分析查看
export const getDupont = data => request().post('finance/dupont', data)
//getChart
export const getChart = data => request().post('finance/chart/view', data)
//数据编辑
export const analyseEdit = data => request().post('finance/analyse/edit', data)
